var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1197 26.4356L65.1838 20.5794V10.8446C65.1838 9.64526 64.2141 8.6756 63.0148 8.6756H49.2866L38.3014 0.433533C37.5359 -0.140605 36.4769 -0.140605 35.6986 0.433533L24.7134 8.6756H10.9852C9.78586 8.6756 8.81621 9.64526 8.81621 10.8446V20.5922L0.880345 26.4484C0.331724 26.8439 0 27.4946 0 28.1835V71.8308C0 73.0301 0.969655 73.9997 2.16897 73.9997H71.831C73.0303 73.9997 74 73.0301 74 71.8308V28.1835C74 27.4946 73.6683 26.8439 73.1197 26.4356ZM69.6621 29.2808V35.5197L65.1838 37.7525V25.9763L69.6621 29.2808ZM37 4.87353L42.0524 8.66284H31.9348L37 4.87353ZM60.8459 13.0135V39.9087L37 51.7742L13.1541 39.8959V13.0135H60.8459ZM8.81621 25.9763V37.7525L4.33793 35.507V29.268L8.81621 25.9763ZM4.33793 69.6618V40.3553L36.0303 56.1377C36.6428 56.4439 37.3572 56.4439 37.9569 56.1377L69.6621 40.3553V69.6618H4.33793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9893 26.0147H50.0169C51.2162 26.0147 52.1858 25.045 52.1858 23.8457C52.1858 22.6464 51.2162 21.6768 50.0169 21.6768H23.9893C22.79 21.6768 21.8203 22.6464 21.8203 23.8457C21.8331 25.045 22.8027 26.0147 23.9893 26.0147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9893 34.6905H37.0031C38.2024 34.6905 39.172 33.7208 39.172 32.5215C39.172 31.3222 38.2024 30.3525 37.0031 30.3525H23.9893C22.79 30.3525 21.8203 31.3222 21.8203 32.5215C21.8203 33.7208 22.8027 34.6905 23.9893 34.6905Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigMail);
export default __webpack_public_path__ + "static/media/big-mail.b5d90954d7af2b4154caf1d9f2123d79.svg";
export { ForwardRef as ReactComponent };